import * as React from "react";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";
import { DropdownOption } from "@teamprevent/common/questionnaires/model";

import { taskActions, secondaryTaskActions } from "./taskActions";
import { Task } from "./task";

export interface TaskWithActionsProps {
    task: TaskModel;
    customerId: string;
    adminUserOptions: DropdownOption[];
}

export function TaskWithActions(props: TaskWithActionsProps & { children?: React.ReactNode }) {

    const actions = (
        <>
            { props.task.actions?.filter(a => taskActions[a])
                .map(a => <div key={a}>{taskActions[a](props.task, props.customerId)}</div>)}
        </>
    );

    const secondaryActions =  (
        <>
            {props.task.actions?.filter(a => secondaryTaskActions[a])
                .map(a => <div key={a}>{secondaryTaskActions[a](props.task, props.customerId)}</div>)}
        </>
    );

    return (
        <Task {...props} actions={actions} secondaryActions={secondaryActions} />
    );
}
